import { UserProfile } from "auth/modules/state";
import { LoadingSpinner } from "@xapp/components";
import { StandardLayout } from "layouts";
import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";
import { Noop } from "utils/Noop";

export interface VerificationPageProps {
    profile: Pick<UserProfile, "emailVerified">;
    confirmVerification(): void;
}

interface VerificationPageState {

}

export class VerificationConfirmationPage extends PureComponent<VerificationPageProps, VerificationPageState> {

    static defaultProps: Partial<VerificationPageProps> = {
        confirmVerification: Noop,
        profile: { emailVerified: false },
    };

    componentWillMount() {
        const { confirmVerification } = this.props;
        confirmVerification();
    }

    render() {
        const { profile } = this.props;
        if (profile && profile.emailVerified) {
            return <Redirect
                to="/"
                push={false} />;
        }
        return (
            <StandardLayout>
                <LoadingSpinner loadingText="We are finishing up your account..." />
            </StandardLayout>
        );
    }
}
